module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/202.d1e43fdf.png";